// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__30cLS","partners__main":"Partners_partners__main__1ENU1","partners__grid":"Partners_partners__grid__3NBL_"};